var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXfi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8.1513L15.2312 4.92009L19.08 4.92004L19.08 8.76888L15.8487 12.0001L19.08 15.2313L19.08 19.0801L15.2312 19.0801L12 15.8489L8.76876 19.0801L4.91993 19.0801L4.91997 15.2313L8.15118 12.0001L4.91997 8.76887L4.91992 4.92008L8.76875 4.92009L12 8.1513ZM11.2359 8.91531L8.3212 6.00057L6.00041 6.00056L6.00044 8.32132L8.91519 11.2361L11.2359 8.91531ZM9.6792 12.0001L12 9.67932L14.3207 12.0001L12 14.3208L9.6792 12.0001ZM8.91519 12.7641L6.00045 15.6788L6.00042 17.9996L8.32121 17.9996L11.2359 15.0849L8.91519 12.7641ZM12.764 15.0849L15.6787 17.9996L17.9995 17.9996L17.9995 15.6788L15.0847 12.7641L12.764 15.0849ZM15.0847 11.2361L12.764 8.91531L15.6787 6.00056L17.9995 6.00053L17.9995 8.32133L15.0847 11.2361Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXfi);
export default __webpack_public_path__ + "static/media/xfi.92134ec3df42f0fe97b551f6c47433c0.svg";
export { ForwardRef as ReactComponent };